<sk-modal-content [title]="headerLabel() | translate"
                  [isHideCloseBtn]="true"
                  [headerCloseIcon]="isUploadingProcess ? 'icon fas fa-arrow-down' : 'far fa-times'"
                  class="upload-files"
                  [class.uploading-process]="isUploadingProcess"
                  confirmByKeypress
                  (confirmed)="uploadAll()"
                  (cancelled)="closeWithoutResult()"
                  (closed)="closeWithoutResult()">

  <div id="sk-modal-body">
    <div class="wrapper-upload-form">
      @if (isUploadingProcess) {
        <div class="upload-files-container">
          <div class="upload-files-content">
            <h1 class="mb-4 fw-bold">
              {{ 'text.dms.FilesUploading' | translate }}:{{ filesInQueueCount() }}
            </h1>
            <div class="mt-2 mb-2 me-5 ms-5">
              <div class="progress">
                <div
                  class="progress-bar progress-bar-success"
                  role="progressbar"
                  [style.width]="uploader()?.progress + '%'"
                ></div>
              </div>
            </div>
            <sk-button
              [appearance]="'outlined'"
              [color]="'primary'"
              class="cancel-upload-btn"
              [label]="'label.CancelUpload' | translate"
              (click)="cancelAll()"
            ></sk-button>
          </div>
        </div>
      }
      @if (queue().length) {
        <div class="wrapper-upload-list">
          <div class="d-flex mb-2">
            @if (!hideForSmallScreen) {
              <sk-toggle
                class="ms-auto"
                [label]="'label.dms.AdvancedUploadingSettings' | translate"
                [(ngModel)]="isEnableAdvancedUploadingSettings"
                [disabled]="isUploadingProcess"
                data-test="upload-files-modal_advanced-uploading-settings"
              ></sk-toggle>
              }
          </div>

          <table class="table">
            <thead>
            <tr>
              <th></th>
              <th>{{ 'label.FileName' | translate | uppercase }}</th>
              @if (!isUploadVersion() && isEnableAdvancedUploadingSettings && !isUploadingProcess) {
                <th>{{ 'label.Tags' | translate | uppercase }}</th>
                <th>{{ 'label.Language' | translate | uppercase }}</th>
              }
              @if (isHTML5()) {
                <th>{{ 'label.Size' | translate | uppercase }}</th>
              }
              <th>{{ 'label.Version' | translate | uppercase }}</th>
              @if (hasZipFile()) {
                <th>{{ 'label.Unzip' | translate | uppercase }}</th>
              }
              <th>{{ 'label.Actions' | translate | uppercase }}</th>
            </tr>
            </thead>
            <tbody>
              @for (item of queue(); track item.file.name) {
                <tr [class.error-uploading-item]="item.isError">
                  <td>{{ $index + 1 }}</td>
                  <td class="file-name">{{ item.file.name }}</td>
                  @if (!isUploadVersion() && isEnableAdvancedUploadingSettings && !isUploadingProcess) {
                    <td>
                      <div class="right-add-button">
                        @for (tag of item.tags; track tag.id) {
                          <i class="fa fa-tag"
                            [style.color]="tag.color || 'grey'"
                            [matTooltip]="tag.name"
                          ></i>
                        }
                        @if (!item.tags?.length) {
                          <div>{{ 'label.NotSet' | translate }}</div>
                        }
                        <iris-dms-select-tags-button
                          icon="fa-plus"
                          [selectedTags]="item.tags"
                          [local]="true"
                          (tagsChanged)="item.tags = $event"
                        ></iris-dms-select-tags-button>
                      </div>
                    </td>
                    <td>
                      <sk-select
                        class="flex-col-3 stick"
                        name="language"
                        bindLabel="title"
                        bindValue="name"
                        [floatLabel]="'never'"
                        [multiple]="true"
                        [placeholder]="'label.Language' | translate"
                        [items]="languages()"
                        [attr.data-test]="'upload-files-modal_language_' + item.file.name"
                        [(ngModel)]="item.contentLanguages">
                      </sk-select>
                    </td>
                  }
                  @if (isHTML5()) {
                    <td nowrap>
                      <p [class.mat-error]="isFileOversized(item.file)">{{ item.file.size | filesize }}</p>
                      @if (isFileOversized(item.file)) {
                        <mat-error class="sk breakable" [innerHTML]="maxFileSizeWarning(item.file)"></mat-error>
                      }
                    </td>
                  }
                  <td>
                    @if (!sameFileType()) {
                      <i
                        [matTooltip]="errorVersionText()"
                        class="fas fa-exclamation-triangle exclamation-triangle-icon"
                      ></i>
                      {{ 'label.dms.DifferentFileTypes' | translate }}
                    }
                    @if (sameFileType() && getVersionLabel(item)()) {
                      <div [hidden]="item.isSuccess || item.isError || item.isCancel" class="m-0 version-number">
                        @if (doesNameExist(item.file.name)()) {
                          <i
                            [matTooltip]="'label.dms.AddFileAsNewVersion' | translate"
                            class="fas fa-exclamation-circle exclamation-circle-icon"
                          ></i>
                        }
                        {{ getVersionLabel(item)() }}
                        @if (doesNameExist(item.file.name)()) {
                          <p class="m-0 rename-button"
                            (click)="showFileRenameDialog(item)">
                            {{'label.dms.RenameFileAndUploadAsNewVersion' | translate}}
                          </p>
                        }
                      </div>
                      <p class="m-0">
                        <i
                          class="fas"
                          [class.fa-ban]="item.isCancel"
                          [class.fa-check-circle.check-circle-icon]="item.isSuccess"
                          [class.fa-exclamation-triangle.exclamation-triangle-icon]="item.isError"
                          [matTooltip]="getIconTooltip(item)"
                        ></i>
                      </p>
                    }
                  </td>
                  @if (hasZipFile()) {
                    <td nowrap>
                      @if (isZipFile(item)) {
                        <sk-checkbox
                          class="mb-0"
                          [attr.data-test]="'upload-files-modal_unzip-file_' + item.file.name"
                          [(ngModel)]="item.unzipFile"
                        ></sk-checkbox>
                      }
                    </td>
                  }
                  <td nowrap>
                    <sk-cell [type]="'actions'">
                      <sk-button
                        [appearance]="'icon'"
                        (click)="removeFile(item)">
                        <i class="icon fas fa-trash"></i>
                      </sk-button>
                      <sk-button
                        [appearance]="'icon'"
                        (click)="showFileRenameDialog(item)">
                        <i class="icon fas fa-pencil"></i>
                      </sk-button>
                    </sk-cell>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  </div>

  <ng-container id="sk-modal-footer-buttons">
    @if (queue().length) {
      <sk-button
        [label]="'label.Upload' | translate"
        [color]="'primary'"
        data-test="modal-footer-confirm-button"
        class="upload-files_upload-button"
        (click)="uploadAll()"
        [disabled]="isUploadDisabled()"
      >
        <ng-template buttonPrefix>
            <i class="fal fa-check check-icon"></i>
        </ng-template>
      </sk-button>
    }
    <sk-button
      data-test="modal-footer-close-button"
      (click)="closeWithoutResult()"
      [label]="'label.Close' | translate"
      [appearance]="'link'"
      [color]="'primary'"
    >
      <ng-template buttonPrefix>
        <i class="far fa-times"></i>
      </ng-template>
    </sk-button>
  </ng-container>
</sk-modal-content>
